import {
  CHILD_ABOUT_STEP,
  CHILD_ABOUT_YOU_STEP,
  CHILD_PRICE_STEP,
} from "Components/Features/CheckPrice/Products/LifeProducts/Child";

import { BooleanFormType } from "Store/interfaces/FormTypes";
import { ChildHealthCoverage } from "Store/interfaces/products/coverage";
import { FormStates } from "Store/priceCalculation/priceCalculationInterfaces";
import { reverseYYYYMMDD } from "Utils/dateUtils";
import { nullableBooleanToNullableFormBoolean } from "Utils/formUtils";
import { isDefined } from "Utils/functions";

export function mapFromCommerceChild(data: { [key: string]: any }): FormStates {
  const {
    childFirstName,
    childDateOfBirth,
    coverageGroup,
    relatedChildHealthProductId,
  } = data;
  const isStayingInNorwayForMoreThanFiveYears =
    nullableBooleanToNullableFormBoolean(
      data.isStayingInNorwayForMoreThanFiveYears,
    );
  const isScandinavianCitizen =
    isStayingInNorwayForMoreThanFiveYears === BooleanFormType.TRUE
      ? BooleanFormType.FALSE
      : BooleanFormType.TRUE;

  return {
    [CHILD_ABOUT_YOU_STEP.id]: {
      isScandinavianCitizen,
      isStayingInNorwayForMoreThanFiveYears,
      pep: BooleanFormType.FALSE,
    },
    [CHILD_ABOUT_STEP.id]: {
      childFirstName,
      childBirthDate: reverseYYYYMMDD(childDateOfBirth),
      parentGuardian: BooleanFormType.TRUE,
    },
    [CHILD_PRICE_STEP.id]: {
      coverage: coverageGroup,
      relatedChildHealthProductId,
      childHealthCoverage: relatedChildHealthProductId
        ? ChildHealthCoverage.CHILD_HEALTH_TREATMENT
        : undefined,
      buyChildHealthInsurance: isDefined(relatedChildHealthProductId)
        ? true
        : false,
    },
  };
}
